import { useEffect, useState } from "react"

import { defaultTimezone } from "@/shared/types"
import { dateTimeFormatInTimeZone, parseUtcDateTime } from "@/shared/utils"

export const useRateConCountdown = (endTimeUtc?: string, timeZone = defaultTimezone) => {
  const [remainingMs, setRemainingMs] = useState<number | null>(null)

  useEffect(() => {
    if (!endTimeUtc) {
      setRemainingMs(null)
      return
    }

    const update = () => {
      const endTimeMs = parseUtcDateTime(endTimeUtc)
      if (endTimeMs === null) {
        setRemainingMs(null)
        return
      }

      const diff = endTimeMs - Date.now()
      setRemainingMs(diff > 0 ? diff : 0)
    }

    update()
    const intervalId = window.setInterval(update, 1000)
    return () => window.clearInterval(intervalId)
  }, [endTimeUtc])

  if (!endTimeUtc || remainingMs === null) {
    return null
  }

  const totalSeconds = Math.floor(remainingMs / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  const countdownLabel =
    remainingMs > 0 ? `${minutes}:${seconds.toString().padStart(2, "0")} remaining` : "Expired"

  const expiresAtLabel =
    dateTimeFormatInTimeZone({
      dateTime: endTimeUtc,
      timeZone,
      format: "MMM d, yyyy hh:mm aa (zzz)",
    }) ?? ""

  return { countdownLabel, expiresAtLabel, isExpired: remainingMs <= 0 }
}
